import { APIMethod, fetchData } from "@client";

export async function logoutUserQuery() {
  await fetchData("/user/logout", APIMethod.POST);
}